export default "__VITE_ASSET__G_NX1Syw__"